﻿export interface INotification {
    content: string;
    id: number;
    isRecalled: boolean;
    linkText: string;
    linkType: string;
    linkURL: string;
    priority: string;
    title: string;
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
export interface ISignalRProxy extends SignalR.Hub.Proxy {
    /**
     * Proxy for the server functions available.
     */
    server: ISignalRProxyServer;

    /**
     * Proxy for the client.
     */
    client: ISignalRProxyClient;
}

export interface ISignalRProxyClient {
    addNotification: (params: string) => void;
    addRecalled: (id: number) => void;
    dismissCallback: (id: number) => void;
}

export interface ISignalRProxyServer {
    interactWithLink: (id: number) => void;
    dismiss: (id: number) => void;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class NotificationManager {
    private static _nHub: ISignalRProxy;

    private static _updateFunction: () => void;

    public static notifications: INotification[];

    public static recalledNotifications: number[];

    public static initialise(): void {
        this.notifications = [];
        this.recalledNotifications = [];

        $.connection.hub.logging = true;
        this._nHub = (
            $.connection as unknown as { notificationHub: ISignalRProxy }
        ).notificationHub;

        this._nHub.client.addNotification = this._addNotification.bind(this);
        this._nHub.client.addRecalled = this._addRecalled.bind(this);
        this._nHub.client.dismissCallback = this._dismissCallback.bind(this);

        void $.connection.hub.start({
            transport: [`webSockets`, `longPolling`],
        });
    }

    public static interactWithLink(id: number): void {
        this._nHub.server.interactWithLink(id);
    }

    public static dismiss(id: number): void {
        this._nHub.server.dismiss(id);
    }

    public static registerUpdate(updateFunc: () => void): void {
        this._updateFunction = updateFunc;
    }

    private static _updateUI(): void {
        if (this._updateFunction) {
            this._updateFunction();
        }
    }

    private static _dismissCallback(id: number): void {
        const index: number = this.notifications.findIndex((n) => n.id === id);

        this.notifications.splice(index, 1);
        this._updateUI();
    }

    private static _addNotification(params: string): void {
        const notification: INotification = JSON.parse(params) as INotification;

        // If this notification is not recalled.
        if (!this.recalledNotifications.find((rn) => rn === notification.id)) {
            const index: number = this.notifications.findIndex(
                (n) => n.id === notification.id,
            );

            if (index === -1) {
                this.notifications.push(notification);
            } else {
                this.notifications[index] = notification;
            }

            this._updateUI();
        }
    }

    private static _addRecalled(id: number): void {
        // If this notification is not already recalled.
        if (!this.recalledNotifications.find((rn) => rn === id)) {
            this.recalledNotifications.push(id);

            const index: number = this.notifications.findIndex(
                (n) => n.id === id,
            );

            if (index !== -1) {
                this.notifications.splice(index, 1);
                this._updateUI();
            }
        }
    }
}
